<script>
export default {
    name: "CreditControlForm",
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:breadcrum>
            <li>Accounts - Credit Control</li>
        </template>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                <h5 class="font-bold text-sm">Credit Control</h5>
              </template>
              <template v-slot:card-body>
                  <tail-patient-details :patient="{}"></tail-patient-details>
                  <table class="table table-bordered table-hover my-2">
                      <thead class="text-sm bg-indigo-400">
                          <tr>
                              <th>Patient</th>
                              <th>IP No</th>
                              <th>OP No</th>
                              <th>Bill No</th>
                              <th>Posted By</th>
                              <th>Amount</th>
                              <th>Cash</th>
                              <th>Deposit</th>
                              <th>Insurance</th>
                              <th>Weivered</th>
                              <th>Balance</th>
                          </tr>
                      </thead>
                      <tbody class="text-xs">
                          <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                          </tr>
                      </tbody>
                  </table>
                  <div class="flex md:flex-row sm:flex-col bg-gray-400 border-2 mt-2">
                      <div class="flex-1 p-1">
                          <h5 class="font-bold">Bills:</h5>
                      </div>
                      <div class="flex-1 p-1">
                          <h5 class="font-bold">Cash:</h5>
                      </div>
                      <div class="flex-1 p-1">
                          <h5 class="font-bold">Deposit Allocated:</h5>
                      </div>
                      <div class="flex-1 p-1">
                          <h5 class="font-bold">Invoiced:</h5>
                      </div>
                      <div class="flex-1 p-1">
                          <h5 class="font-bold">Weivered:</h5>
                      </div>
                      <div class="flex-1 p-1">
                          <h5 class="font-bold">Balance:</h5>
                      </div>
                  </div>
                  <div class="flex flex-row justify-end p-1 mt-2">
                      <button class="btn-primary text-sm"><i class="fa fa-save"></i> Proceed</button>
                  </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>